import { Injectable } from '@angular/core';
import { HisBackendService } from 'hisng';
import { Observable } from 'rxjs';
import { Person } from 'app/cs/psv/common/model/person/person';
import { PsvPersonProfile } from 'app/cs/psv/common/model/person/psvPersonProfile';
import { Term } from '../model/person/exaModels';

@Injectable()
export class PersonService {

    constructor( private backendService: HisBackendService ) { }

    getPersonById( id: number ): Observable<Person> {
        return this.backendService.getData( `api/v1/cs/psv/person/${id}/reducedData` );
    }

    getPersonProfileByPersonId( id: number ): Observable<PsvPersonProfile> {
        return this.backendService.getData( `api/v1/cs/psv/person/${id}/details` );
    }

    /**
     * let the backend verify the rights if the auth can see person profiles
     * (need to be in BE because we cant check rightsparameter in FE)
     *
     * @param id of person
     */
    checkForViewPersonProfileRights( id: number ): Observable<any> {
        return this.backendService.getData( `api/v1/cs/psv/personProfile/hasVisibleAffiliations/${id}` );
    }

    getCurrentLectureTerm(): Observable<Term> {
        return this.backendService.getData( 'api/v1/cs/psv/lectureTerm' );
    }

    serchForOrcidIds(keyword: any): Observable<any> {
        return this.backendService.getData( `api/v1/cs/psv/orcid/import?q=${keyword}`);
    }

    inportOrcidIds( jobRequest: any ): Observable<any> {
        return this.backendService.postData( 'api/v1/cs/sys/jobExecution', jobRequest );
    }

    canEditPersonProfilEntry(id: number): Observable<boolean> {
        return this.backendService.postData(
            `api/v1/fs/res/hasRightsOnObject/PersonProfileEntry/${id}/true`,
            [
                'RIGHT_FS_RES_PROJECT_EDIT_PROJECT',
                'RIGHT_FS_RES_PROJECT_EDIT_PROJECT_OWN',
            ]
        );
    }
}
